export default __webpack_public_path__ + "static/media/hospital.c396785b.png";